import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPartnerProfile$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPartnerProfile extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a8e570cc2b5b447e3fb49e3088d93712ffa6aeb5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7aae677596547104f3de2a909c7668e9bc7277a7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'cc2296911f081dd79297519155bc0f0e930bf73e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.001 3.75c.74 0 1.445.32 1.933.878.468.61.662 1.387.537 2.146l-.179 1.7a2.291 2.291 0 0 1-4.582-.001l-.182-1.713a2.78 2.78 0 0 1 .54-2.134A2.57 2.57 0 0 1 15 3.75M8.63 14.471a.32.32 0 0 1 .266-.021 3.9 3.9 0 0 1 2.602 3.463.323.323 0 0 1-.324.337h-8.35a.32.32 0 0 1-.325-.337 3.9 3.9 0 0 1 2.602-3.463.32.32 0 0 1 .267.021 3.56 3.56 0 0 0 3.261 0m.302-6.842A2.43 2.43 0 0 0 7 6.752a2.43 2.43 0 0 0-1.933.876 2.78 2.78 0 0 0-.54 2.133l.181 1.712a2.291 2.291 0 1 0 4.582.001l.18-1.698a2.78 2.78 0 0 0-.537-2.147m7.696 3.842a.33.33 0 0 1 .27-.021 3.9 3.9 0 0 1 2.6 3.46.325.325 0 0 1-.325.34h-6.758a.5.5 0 0 1-.405-.217 5.3 5.3 0 0 0-.955-1.039.5.5 0 0 1-.155-.597 3.97 3.97 0 0 1 2.2-1.947.33.33 0 0 1 .269.021 3.56 3.56 0 0 0 3.26 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-partner-profile", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-partner-profile"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-partner-profile":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPartnerProfile$1);
            }
            break;
    } });
}

const CosmosIconPartnerProfile = CosmosIconPartnerProfile$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPartnerProfile, defineCustomElement };
